import { createFileRoute } from '@tanstack/react-router'

import { OrchestrationStudio } from '@/features/orchestration/components/orchestration-studio'

interface OrchestrationSearch {
  view?: 'graph' | 'list'
  agentId?: string
}

/** Home route — the orchestration studio. */
export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): OrchestrationSearch => ({
    view: search.view === 'list' ? 'list' : undefined,
    agentId: typeof search.agentId === 'string' ? search.agentId : undefined,
  }),
  component: HomeRoute,
})

function HomeRoute() {
  const search = Route.useSearch()
  return <OrchestrationStudio initialView={search.view} initialAgentId={search.agentId} />
}
